// Author Lin
// Date 2024-05-15 12:54:02

class SithMesMstMaterial {
constructor({
        id = null,
        status = '',
        workOrderCode = '',
        projectKamId = '',
        bg = '',
        standardPart = '',
        material = '',
        plant = '',
        materialDescription = '',
        engDescription = '',
        longText = '',
        language = '',
        mtype = '',
        bunit = '',
        salesOrg = '',
        distChannel = '',
        oldMaterialNo = '',
        matGroup = '',
        externalMaterialGroup = '',
        siemensPartNumber = '',
        taxCategory = '',
        taxClass = '',
        minOrderQty = '',
        deliveryPlant = '',
        minDeliveryQty = '',
        cashDiscount = '',
        matPricingGroup = '',
        accountGroup = '',
        matStatisticsGroup = '',
        generalItemCategoryGroup = '',
        itemCategoryGroup = '',
        productHierarchy = '',
        loadingGroup = '',
        availabilityCheck = '',
        profitCenter = '',
        transportGroup = '',
        grGiNumber = '',
        storageBin = '',
        overheadGroup = '',
        valuationClass = '',
        priceUnit = '',
        lotSizeCostEstimate = '',
        standardPrice = '',
        priceControl = '',
        withQtyStructure = '',
        matOrigin = '',
        lotSize = '',
        mrp = '',
        mrpType = '',
        mrpController = '',
        schedulingMarginKey = '',
        consumptionMode = '',
        fwdConsPer = '',
        bwdConsPer = '',
        mixedMrpIndicator = '',
        proSheProfile = '',
        specialProcType = '',
        strategyGroup = '',
        recordPoint = '',
        minLotSze = '',
        maxLotSize = '',
        fixLotSize = '',
        maxStockLevel = '',
        procType = '',
        purchasingGroup = '',
        defaultStorageLocation = '',
        issueStorageLocation = '',
        plannedDeliveryTime = '',
        grProcessingTime = '',
        safeStock = '',
        individualColl = '',
        inHouseProductionTime = '',
        interOperationTime = '',
        issueUnit = '',
        materialDescriptionZH = '',
        textId = '',
        languageKey = '',
        textMp = '',
        textEng = '',
        textQa = '',
        safetyTime1 = '',
        safetyTime2 = '',
        pl = '',
        isDeposited = '',
        followUpMaterial = '',
        efODate = '',
        bulk = '',
        esloc = '',
        sloc = '',
        roundingVal = '',
        b = '',
        srceList = '',
        inspectionInterval = '',
        codeNumber = '',
        movavgPrice = '',
        ms = '',
        productNumberSort = '',
        industryStdDesc = '',
        bmr = '',
        grossWeight = '',
        netWeight = '',
        weightUnit = '',
        dimensions = '',
        inspectionMemo = '',
        basicMaterial = '',
        documentNumber = '',
        documentVersion = '',
        reserve1 = '',
        reserve2 = '',
        reserve3 = '',
        reserve4 = '',
        reserve5 = '',
        makeOrBuy = '',
        maintenanceStatus = '',
        baMaintainer = '',
        baMaintainTime = '',
        omMaintainer = '',
        omMaintainTime = '',
        tcMaintainer = '',
        tcMaintainTime = '',
        mpMaintainer = '',
        mpMaintainTime = '',
        qmMaintainer = '',
        qmMaintainTime = '',
        purchaser = '',
        purchaserMaintainTime = '',
        doMaintainer = '',
        doMaintainTime = '',
        remark = '',
        createdBy = '',
        currentUserField = '',
        currentDateField = ''}
= {}) {
    this.id = id;
    this.status = status;
    this.workOrderCode = workOrderCode;
    this.projectKamId = projectKamId;
    this.bg = bg;
    this.standardPart = standardPart;
    this.material = material;
    this.plant = plant;
    this.materialDescription = materialDescription;
    this.engDescription = engDescription;
    this.longText = longText;
    this.language = language;
    this.mtype = mtype;
    this.bunit = bunit;
    this.salesOrg = salesOrg;
    this.distChannel = distChannel;
    this.oldMaterialNo = oldMaterialNo;
    this.matGroup = matGroup;
    this.externalMaterialGroup = externalMaterialGroup;
    this.siemensPartNumber = siemensPartNumber;
    this.taxCategory = taxCategory;
    this.taxClass = taxClass;
    this.minOrderQty = minOrderQty;
    this.deliveryPlant = deliveryPlant;
    this.minDeliveryQty = minDeliveryQty;
    this.cashDiscount = cashDiscount;
    this.matPricingGroup = matPricingGroup;
    this.accountGroup = accountGroup;
    this.matStatisticsGroup = matStatisticsGroup;
    this.generalItemCategoryGroup = generalItemCategoryGroup;
    this.itemCategoryGroup = itemCategoryGroup;
    this.productHierarchy = productHierarchy;
    this.loadingGroup = loadingGroup;
    this.availabilityCheck = availabilityCheck;
    this.profitCenter = profitCenter;
    this.transportGroup = transportGroup;
    this.grGiNumber = grGiNumber;
    this.storageBin = storageBin;
    this.overheadGroup = overheadGroup;
    this.valuationClass = valuationClass;
    this.priceUnit = priceUnit;
    this.lotSizeCostEstimate = lotSizeCostEstimate;
    this.standardPrice = standardPrice;
    this.priceControl = priceControl;
    this.withQtyStructure = withQtyStructure;
    this.matOrigin = matOrigin;
    this.lotSize = lotSize;
    this.mrp = mrp;
    this.mrpType = mrpType;
    this.mrpController = mrpController;
    this.schedulingMarginKey = schedulingMarginKey;
    this.consumptionMode = consumptionMode;
    this.fwdConsPer = fwdConsPer;
    this.bwdConsPer = bwdConsPer;
    this.mixedMrpIndicator = mixedMrpIndicator;
    this.proSheProfile = proSheProfile;
    this.specialProcType = specialProcType;
    this.strategyGroup = strategyGroup;
    this.recordPoint = recordPoint;
    this.minLotSze = minLotSze;
    this.maxLotSize = maxLotSize;
    this.fixLotSize = fixLotSize;
    this.maxStockLevel = maxStockLevel;
    this.procType = procType;
    this.purchasingGroup = purchasingGroup;
    this.defaultStorageLocation = defaultStorageLocation;
    this.issueStorageLocation = issueStorageLocation;
    this.plannedDeliveryTime = plannedDeliveryTime;
    this.grProcessingTime = grProcessingTime;
    this.safeStock = safeStock;
    this.individualColl = individualColl;
    this.inHouseProductionTime = inHouseProductionTime;
    this.interOperationTime = interOperationTime;
    this.issueUnit = issueUnit;
    this.materialDescriptionZH = materialDescriptionZH;
    this.textId = textId;
    this.languageKey = languageKey;
    this.textMp = textMp;
    this.textEng = textEng;
    this.textQa = textQa;
    this.safetyTime1 = safetyTime1;
    this.safetyTime2 = safetyTime2;
    this.pl = pl;
    this.isDeposited = isDeposited;
    this.followUpMaterial = followUpMaterial;
    this.efODate = efODate;
    this.bulk = bulk;
    this.esloc = esloc;
    this.sloc = sloc;
    this.roundingVal = roundingVal;
    this.b = b;
    this.srceList = srceList;
    this.inspectionInterval = inspectionInterval;
    this.codeNumber = codeNumber;
    this.movavgPrice = movavgPrice;
    this.ms = ms;
    this.productNumberSort = productNumberSort;
    this.industryStdDesc = industryStdDesc;
    this.bmr = bmr;
    this.grossWeight = grossWeight;
    this.netWeight = netWeight;
    this.weightUnit = weightUnit;
    this.dimensions = dimensions;
    this.inspectionMemo = inspectionMemo;
    this.basicMaterial = basicMaterial;
    this.documentNumber = documentNumber;
    this.documentVersion = documentVersion;
    this.reserve1 = reserve1;
    this.reserve2 = reserve2;
    this.reserve3 = reserve3;
    this.reserve4 = reserve4;
    this.reserve5 = reserve5;
    this.makeOrBuy = makeOrBuy;
    this.maintenanceStatus = maintenanceStatus;
    this.baMaintainer = baMaintainer;
    this.baMaintainTime = baMaintainTime;
    this.omMaintainer = omMaintainer;
    this.omMaintainTime = omMaintainTime;
    this.tcMaintainer = tcMaintainer;
    this.tcMaintainTime = tcMaintainTime;
    this.mpMaintainer = mpMaintainer;
    this.mpMaintainTime = mpMaintainTime;
    this.qmMaintainer = qmMaintainer;
    this.qmMaintainTime = qmMaintainTime;
    this.purchaser = purchaser;
    this.purchaserMaintainTime = purchaserMaintainTime;
    this.doMaintainer = doMaintainer;
    this.doMaintainTime = doMaintainTime;
    this.remark = remark;
    this.createdBy = createdBy;
    this.currentUserField = currentUserField;
    this.currentDateField = currentDateField;
}
}

function newEntity() {
return new SithMesMstMaterial();
}

const editViewVoConfigs = [
        {
        key: 'projectCode',
        label: 'label.sith.mst.sithMesMstMaterial.grid.projectCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'machine1',
        label: 'label.sith.mst.sithMesMstMaterial.grid.machine1',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'bg',
        label: 'label.sith.mst.sithMesMstMaterial.grid.bg',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'standardPart',
        label: 'label.sith.mst.sithMesMstMaterial.grid.standardPart',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'material',
        label: 'label.sith.mst.sithMesMstMaterial.grid.material',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'plant',
        label: 'label.sith.mst.sithMesMstMaterial.grid.plant',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'engDescription',
        label: 'label.sith.mst.sithMesMstMaterial.grid.engDescription',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'longText',
        label: 'label.sith.mst.sithMesMstMaterial.grid.longText',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'language',
        label: 'label.sith.mst.sithMesMstMaterial.grid.language',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mtype',
        label: 'label.sith.mst.sithMesMstMaterial.grid.mtype',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'bunit',
        label: 'label.sith.mst.sithMesMstMaterial.grid.bunit',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'salesOrg',
        label: 'label.sith.mst.sithMesMstMaterial.grid.salesOrg',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'distChannel',
        label: 'label.sith.mst.sithMesMstMaterial.grid.distChannel',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'oldMaterialNo',
        label: 'label.sith.mst.sithMesMstMaterial.grid.oldMaterialNo',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'matGroup',
        label: 'label.sith.mst.sithMesMstMaterial.grid.matGroup',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'externalMaterialGroup',
        label: 'label.sith.mst.sithMesMstMaterial.grid.externalMaterialGroup',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'siemensPartNumber',
        label: 'label.sith.mst.sithMesMstMaterial.grid.siemensPartNumber',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'taxCategory',
        label: 'label.sith.mst.sithMesMstMaterial.grid.taxCategory',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'taxClass',
        label: 'label.sith.mst.sithMesMstMaterial.grid.taxClass',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'minOrderQty',
        label: 'label.sith.mst.sithMesMstMaterial.grid.minOrderQty',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'deliveryPlant',
        label: 'label.sith.mst.sithMesMstMaterial.grid.deliveryPlant',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'minDeliveryQty',
        label: 'label.sith.mst.sithMesMstMaterial.grid.minDeliveryQty',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'cashDiscount',
        label: 'label.sith.mst.sithMesMstMaterial.grid.cashDiscount',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'matPricingGroup',
        label: 'label.sith.mst.sithMesMstMaterial.grid.matPricingGroup',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'accountGroup',
        label: 'label.sith.mst.sithMesMstMaterial.grid.accountGroup',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'matStatisticsGroup',
        label: 'label.sith.mst.sithMesMstMaterial.grid.matStatisticsGroup',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'generalItemCategoryGroup',
        label: 'label.sith.mst.sithMesMstMaterial.grid.generalItemCategoryGroup',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'itemCategoryGroup',
        label: 'label.sith.mst.sithMesMstMaterial.grid.itemCategoryGroup',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'productHierarchy',
        label: 'label.sith.mst.sithMesMstMaterial.grid.productHierarchy',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'loadingGroup',
        label: 'label.sith.mst.sithMesMstMaterial.grid.loadingGroup',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'availabilityCheck',
        label: 'label.sith.mst.sithMesMstMaterial.grid.availabilityCheck',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'profitCenter',
        label: 'label.sith.mst.sithMesMstMaterial.grid.profitCenter',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'transportGroup',
        label: 'label.sith.mst.sithMesMstMaterial.grid.transportGroup',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'grGiNumber',
        label: 'label.sith.mst.sithMesMstMaterial.grid.grGiNumber',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'storageBin',
        label: 'label.sith.mst.sithMesMstMaterial.grid.storageBin',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'overheadGroup',
        label: 'label.sith.mst.sithMesMstMaterial.grid.overheadGroup',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'valuationClass',
        label: 'label.sith.mst.sithMesMstMaterial.grid.valuationClass',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'priceUnit',
        label: 'label.sith.mst.sithMesMstMaterial.grid.priceUnit',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'lotSizeCostEstimate',
        label: 'label.sith.mst.sithMesMstMaterial.grid.lotSizeCostEstimate',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'standardPrice',
        label: 'label.sith.mst.sithMesMstMaterial.grid.standardPrice',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'priceControl',
        label: 'label.sith.mst.sithMesMstMaterial.grid.priceControl',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'withQtyStructure',
        label: 'label.sith.mst.sithMesMstMaterial.grid.withQtyStructure',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'matOrigin',
        label: 'label.sith.mst.sithMesMstMaterial.grid.matOrigin',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'lotSize',
        label: 'label.sith.mst.sithMesMstMaterial.grid.lotSize',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mrp',
        label: 'label.sith.mst.sithMesMstMaterial.grid.mrp',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mrpType',
        label: 'label.sith.mst.sithMesMstMaterial.grid.mrpType',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mrpController',
        label: 'label.sith.mst.sithMesMstMaterial.grid.mrpController',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'schedulingMarginKey',
        label: 'label.sith.mst.sithMesMstMaterial.grid.schedulingMarginKey',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'consumptionMode',
        label: 'label.sith.mst.sithMesMstMaterial.grid.consumptionMode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'fwdConsPer',
        label: 'label.sith.mst.sithMesMstMaterial.grid.fwdConsPer',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'bwdConsPer',
        label: 'label.sith.mst.sithMesMstMaterial.grid.bwdConsPer',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mixedMrpIndicator',
        label: 'label.sith.mst.sithMesMstMaterial.grid.mixedMrpIndicator',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'proSheProfile',
        label: 'label.sith.mst.sithMesMstMaterial.grid.proSheProfile',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'specialProcType',
        label: 'label.sith.mst.sithMesMstMaterial.grid.specialProcType',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'strategyGroup',
        label: 'label.sith.mst.sithMesMstMaterial.grid.strategyGroup',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'recordPoint',
        label: 'label.sith.mst.sithMesMstMaterial.grid.recordPoint',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'minLotSze',
        label: 'label.sith.mst.sithMesMstMaterial.grid.minLotSze',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'maxLotSize',
        label: 'label.sith.mst.sithMesMstMaterial.grid.maxLotSize',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'fixLotSize',
        label: 'label.sith.mst.sithMesMstMaterial.grid.fixLotSize',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'maxStockLevel',
        label: 'label.sith.mst.sithMesMstMaterial.grid.maxStockLevel',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'procType',
        label: 'label.sith.mst.sithMesMstMaterial.grid.procType',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'purchasingGroup',
        label: 'label.sith.mst.sithMesMstMaterial.grid.purchasingGroup',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'defaultStorageLocation',
        label: 'label.sith.mst.sithMesMstMaterial.grid.defaultStorageLocation',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'issueStorageLocation',
        label: 'label.sith.mst.sithMesMstMaterial.grid.issueStorageLocation',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'plannedDeliveryTime',
        label: 'label.sith.mst.sithMesMstMaterial.grid.plannedDeliveryTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'grProcessingTime',
        label: 'label.sith.mst.sithMesMstMaterial.grid.grProcessingTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'safeStock',
        label: 'label.sith.mst.sithMesMstMaterial.grid.safeStock',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'individualColl',
        label: 'label.sith.mst.sithMesMstMaterial.grid.individualColl',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'inHouseProductionTime',
        label: 'label.sith.mst.sithMesMstMaterial.grid.inHouseProductionTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'interOperationTime',
        label: 'label.sith.mst.sithMesMstMaterial.grid.interOperationTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'issueUnit',
        label: 'label.sith.mst.sithMesMstMaterial.grid.issueUnit',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'materialDescriptionZH',
        label: 'label.sith.mst.sithMesMstMaterial.grid.materialDescriptionZH',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'textId',
        label: 'label.sith.mst.sithMesMstMaterial.grid.textId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'languageKey',
        label: 'label.sith.mst.sithMesMstMaterial.grid.languageKey',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'textMp',
        label: 'label.sith.mst.sithMesMstMaterial.grid.textMp',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'textEng',
        label: 'label.sith.mst.sithMesMstMaterial.grid.textEng',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'textQa',
        label: 'label.sith.mst.sithMesMstMaterial.grid.textQa',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'safetyTime1',
        label: 'label.sith.mst.sithMesMstMaterial.grid.safetyTime1',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'safetyTime2',
        label: 'label.sith.mst.sithMesMstMaterial.grid.safetyTime2',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'scope',
        label: 'label.sith.mst.sithMesMstMaterial.grid.scope',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: 'SAG' },
                            { value: '2', text: 'SITH' },
                            { value: '3', text: 'MIXED' }
            ]
                }
        },
        {
        key: 'materialDirection',
        label: 'label.sith.mst.sithMesMstMaterial.grid.materialDirection',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: 'R' },
                            { value: '2', text: '3rd' },
                            { value: '3', text: 'P' }
            ]
                }
        }
    ]
const sithMesMstMaterialBasicVoConfigs = [
        {
        key: 'id',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'plant',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.plant',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'material',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.material',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'materialDescriptionZH',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.materialDescriptionZH',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'engDescription',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.engDescription',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'language',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.language',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mtype',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.mtype',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'bunit',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.bunit',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'procType',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.procType',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'specialProcType',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.specialProcType',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mrpType',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.mrpType',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mrpController',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.mrpController',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'lotSize',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.lotSize',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'individualColl',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.individualColl',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'itemCategoryGroup',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.itemCategoryGroup',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'followUpMaterial',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.followUpMaterial',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'efODate',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.efODate',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'bulk',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.bulk',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'esloc',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.esloc',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'sloc',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.sloc',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'safeStock',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.safeStock',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'recordPoint',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.recordPoint',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'minLotSze',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.minLotSze',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'roundingVal',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.roundingVal',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'b',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.b',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'srceList',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.srceList',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'purchasingGroup',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.purchasingGroup',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'matGroup',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.matGroup',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'plannedDeliveryTime',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.plannedDeliveryTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'inHouseProductionTime',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.inHouseProductionTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'grProcessingTime',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.grProcessingTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'inspectionInterval',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.inspectionInterval',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'codeNumber',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.codeNumber',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'salesOrg',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.salesOrg',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'distChannel',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.distChannel',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'productHierarchy',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.productHierarchy',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'profitCenter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.profitCenter',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'loadingGroup',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.loadingGroup',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'overheadGroup',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.overheadGroup',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'valuationClass',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.valuationClass',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'priceControl',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.priceControl',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'movavgPrice',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.movavgPrice',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'standardPrice',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.standardPrice',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'priceUnit',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.priceUnit',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'availabilityCheck',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.availabilityCheck',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mrp',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.mrp',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ms',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.ms',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'consumptionMode',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.consumptionMode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'strategyGroup',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.strategyGroup',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'bwdConsPer',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.bwdConsPer',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'fwdConsPer',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.fwdConsPer',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'schedulingMarginKey',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.schedulingMarginKey',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'safetyTime1',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.safetyTime1',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'safetyTime2',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.safetyTime2',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'oldMaterialNo',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.oldMaterialNo',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'productNumberSort',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.productNumberSort',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'industryStdDesc',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.industryStdDesc',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'bmr',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.bmr',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'grossWeight',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.grossWeight',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'netWeight',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.netWeight',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'weightUnit',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.weightUnit',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'height',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.height',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'width',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.width',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'length',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.length',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'dimensions',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.dimensions',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'volume',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.volume',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'volumeUnit',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.volumeUnit',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'warehouseNumber',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.warehouseNumber',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'longText',
        label: 'label.sith.mst.sithMesMstMaterialBasic.grid.longText',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        }
    ]
    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.mst.sithMesMstMaterial.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'statusName',
        label: 'label.sith.mst.sithMesMstMaterial.grid.statusName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'workOrderCode',
        label: 'label.sith.mst.sithMesMstMaterial.grid.workOrderCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'projectKamId',
        label: 'label.sith.mst.sithMesMstMaterial.grid.projectKamId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'projectCode',
        label: 'label.sith.mst.sithMesMstMaterial.grid.projectCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'machine1',
        label: 'label.sith.mst.sithMesMstMaterial.grid.machine1',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'bg',
        label: 'label.sith.mst.sithMesMstMaterial.grid.bg',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'standardPart',
        label: 'label.sith.mst.sithMesMstMaterial.grid.standardPart',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'material',
        label: 'label.sith.mst.sithMesMstMaterial.grid.material',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'plant',
        label: 'label.sith.mst.sithMesMstMaterial.grid.plant',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'engDescription',
        label: 'label.sith.mst.sithMesMstMaterial.grid.engDescription',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'longText',
        label: 'label.sith.mst.sithMesMstMaterial.grid.longText',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'language',
        label: 'label.sith.mst.sithMesMstMaterial.grid.language',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mtype',
        label: 'label.sith.mst.sithMesMstMaterial.grid.mtype',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'bunit',
        label: 'label.sith.mst.sithMesMstMaterial.grid.bunit',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'salesOrg',
        label: 'label.sith.mst.sithMesMstMaterial.grid.salesOrg',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'distChannel',
        label: 'label.sith.mst.sithMesMstMaterial.grid.distChannel',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'oldMaterialNo',
        label: 'label.sith.mst.sithMesMstMaterial.grid.oldMaterialNo',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'matGroup',
        label: 'label.sith.mst.sithMesMstMaterial.grid.matGroup',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'externalMaterialGroup',
        label: 'label.sith.mst.sithMesMstMaterial.grid.externalMaterialGroup',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'siemensPartNumber',
        label: 'label.sith.mst.sithMesMstMaterial.grid.siemensPartNumber',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'taxCategory',
        label: 'label.sith.mst.sithMesMstMaterial.grid.taxCategory',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'taxClass',
        label: 'label.sith.mst.sithMesMstMaterial.grid.taxClass',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'minOrderQty',
        label: 'label.sith.mst.sithMesMstMaterial.grid.minOrderQty',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'deliveryPlant',
        label: 'label.sith.mst.sithMesMstMaterial.grid.deliveryPlant',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'minDeliveryQty',
        label: 'label.sith.mst.sithMesMstMaterial.grid.minDeliveryQty',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'cashDiscount',
        label: 'label.sith.mst.sithMesMstMaterial.grid.cashDiscount',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'matPricingGroup',
        label: 'label.sith.mst.sithMesMstMaterial.grid.matPricingGroup',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'accountGroup',
        label: 'label.sith.mst.sithMesMstMaterial.grid.accountGroup',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'matStatisticsGroup',
        label: 'label.sith.mst.sithMesMstMaterial.grid.matStatisticsGroup',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'generalItemCategoryGroup',
        label: 'label.sith.mst.sithMesMstMaterial.grid.generalItemCategoryGroup',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'itemCategoryGroup',
        label: 'label.sith.mst.sithMesMstMaterial.grid.itemCategoryGroup',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'productHierarchy',
        label: 'label.sith.mst.sithMesMstMaterial.grid.productHierarchy',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'loadingGroup',
        label: 'label.sith.mst.sithMesMstMaterial.grid.loadingGroup',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'availabilityCheck',
        label: 'label.sith.mst.sithMesMstMaterial.grid.availabilityCheck',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'profitCenter',
        label: 'label.sith.mst.sithMesMstMaterial.grid.profitCenter',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'transportGroup',
        label: 'label.sith.mst.sithMesMstMaterial.grid.transportGroup',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'grGiNumber',
        label: 'label.sith.mst.sithMesMstMaterial.grid.grGiNumber',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'storageBin',
        label: 'label.sith.mst.sithMesMstMaterial.grid.storageBin',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'overheadGroup',
        label: 'label.sith.mst.sithMesMstMaterial.grid.overheadGroup',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'valuationClass',
        label: 'label.sith.mst.sithMesMstMaterial.grid.valuationClass',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'priceUnit',
        label: 'label.sith.mst.sithMesMstMaterial.grid.priceUnit',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'lotSizeCostEstimate',
        label: 'label.sith.mst.sithMesMstMaterial.grid.lotSizeCostEstimate',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'standardPrice',
        label: 'label.sith.mst.sithMesMstMaterial.grid.standardPrice',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'priceControl',
        label: 'label.sith.mst.sithMesMstMaterial.grid.priceControl',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'withQtyStructure',
        label: 'label.sith.mst.sithMesMstMaterial.grid.withQtyStructure',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'matOrigin',
        label: 'label.sith.mst.sithMesMstMaterial.grid.matOrigin',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'lotSize',
        label: 'label.sith.mst.sithMesMstMaterial.grid.lotSize',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mrp',
        label: 'label.sith.mst.sithMesMstMaterial.grid.mrp',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mrpType',
        label: 'label.sith.mst.sithMesMstMaterial.grid.mrpType',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mrpController',
        label: 'label.sith.mst.sithMesMstMaterial.grid.mrpController',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'schedulingMarginKey',
        label: 'label.sith.mst.sithMesMstMaterial.grid.schedulingMarginKey',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'consumptionMode',
        label: 'label.sith.mst.sithMesMstMaterial.grid.consumptionMode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'fwdConsPer',
        label: 'label.sith.mst.sithMesMstMaterial.grid.fwdConsPer',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'bwdConsPer',
        label: 'label.sith.mst.sithMesMstMaterial.grid.bwdConsPer',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mixedMrpIndicator',
        label: 'label.sith.mst.sithMesMstMaterial.grid.mixedMrpIndicator',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'proSheProfile',
        label: 'label.sith.mst.sithMesMstMaterial.grid.proSheProfile',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'specialProcType',
        label: 'label.sith.mst.sithMesMstMaterial.grid.specialProcType',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'strategyGroup',
        label: 'label.sith.mst.sithMesMstMaterial.grid.strategyGroup',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'recordPoint',
        label: 'label.sith.mst.sithMesMstMaterial.grid.recordPoint',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'minLotSze',
        label: 'label.sith.mst.sithMesMstMaterial.grid.minLotSze',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'maxLotSize',
        label: 'label.sith.mst.sithMesMstMaterial.grid.maxLotSize',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'fixLotSize',
        label: 'label.sith.mst.sithMesMstMaterial.grid.fixLotSize',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'maxStockLevel',
        label: 'label.sith.mst.sithMesMstMaterial.grid.maxStockLevel',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'procType',
        label: 'label.sith.mst.sithMesMstMaterial.grid.procType',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'purchasingGroup',
        label: 'label.sith.mst.sithMesMstMaterial.grid.purchasingGroup',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'defaultStorageLocation',
        label: 'label.sith.mst.sithMesMstMaterial.grid.defaultStorageLocation',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'issueStorageLocation',
        label: 'label.sith.mst.sithMesMstMaterial.grid.issueStorageLocation',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'plannedDeliveryTime',
        label: 'label.sith.mst.sithMesMstMaterial.grid.plannedDeliveryTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'grProcessingTime',
        label: 'label.sith.mst.sithMesMstMaterial.grid.grProcessingTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'safeStock',
        label: 'label.sith.mst.sithMesMstMaterial.grid.safeStock',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'individualColl',
        label: 'label.sith.mst.sithMesMstMaterial.grid.individualColl',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'inHouseProductionTime',
        label: 'label.sith.mst.sithMesMstMaterial.grid.inHouseProductionTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'interOperationTime',
        label: 'label.sith.mst.sithMesMstMaterial.grid.interOperationTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'issueUnit',
        label: 'label.sith.mst.sithMesMstMaterial.grid.issueUnit',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'materialDescriptionZH',
        label: 'label.sith.mst.sithMesMstMaterial.grid.materialDescriptionZH',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'textId',
        label: 'label.sith.mst.sithMesMstMaterial.grid.textId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'languageKey',
        label: 'label.sith.mst.sithMesMstMaterial.grid.languageKey',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'textMp',
        label: 'label.sith.mst.sithMesMstMaterial.grid.textMp',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'textEng',
        label: 'label.sith.mst.sithMesMstMaterial.grid.textEng',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'textQa',
        label: 'label.sith.mst.sithMesMstMaterial.grid.textQa',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'safetyTime1',
        label: 'label.sith.mst.sithMesMstMaterial.grid.safetyTime1',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'safetyTime2',
        label: 'label.sith.mst.sithMesMstMaterial.grid.safetyTime2',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'scope',
        label: 'label.sith.mst.sithMesMstMaterial.grid.scope',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: 'SAG' },
                            { value: '2', text: 'SITH' },
                            { value: '3', text: 'MIXED' }
            ]
                }
        },
        {
        key: 'materialDirection',
        label: 'label.sith.mst.sithMesMstMaterial.grid.materialDirection',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: 'R' },
                            { value: '2', text: '3rd' },
                            { value: '3', text: 'P' }
            ]
                }
        },
        {
        key: 'pl',
        label: 'label.sith.mst.sithMesMstMaterial.grid.pl',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'isDeposited',
        label: 'label.sith.mst.sithMesMstMaterial.grid.isDeposited',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'followUpMaterial',
        label: 'label.sith.mst.sithMesMstMaterial.grid.followUpMaterial',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'efODate',
        label: 'label.sith.mst.sithMesMstMaterial.grid.efODate',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'bulk',
        label: 'label.sith.mst.sithMesMstMaterial.grid.bulk',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'esloc',
        label: 'label.sith.mst.sithMesMstMaterial.grid.esloc',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'sloc',
        label: 'label.sith.mst.sithMesMstMaterial.grid.sloc',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'roundingVal',
        label: 'label.sith.mst.sithMesMstMaterial.grid.roundingVal',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'b',
        label: 'label.sith.mst.sithMesMstMaterial.grid.b',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'srceList',
        label: 'label.sith.mst.sithMesMstMaterial.grid.srceList',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'inspectionInterval',
        label: 'label.sith.mst.sithMesMstMaterial.grid.inspectionInterval',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'codeNumber',
        label: 'label.sith.mst.sithMesMstMaterial.grid.codeNumber',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'movavgPrice',
        label: 'label.sith.mst.sithMesMstMaterial.grid.movavgPrice',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ms',
        label: 'label.sith.mst.sithMesMstMaterial.grid.ms',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'productNumberSort',
        label: 'label.sith.mst.sithMesMstMaterial.grid.productNumberSort',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'industryStdDesc',
        label: 'label.sith.mst.sithMesMstMaterial.grid.industryStdDesc',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'bmr',
        label: 'label.sith.mst.sithMesMstMaterial.grid.bmr',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'grossWeight',
        label: 'label.sith.mst.sithMesMstMaterial.grid.grossWeight',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'netWeight',
        label: 'label.sith.mst.sithMesMstMaterial.grid.netWeight',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'weightUnit',
        label: 'label.sith.mst.sithMesMstMaterial.grid.weightUnit',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'dimensions',
        label: 'label.sith.mst.sithMesMstMaterial.grid.dimensions',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'inspectionMemo',
        label: 'label.sith.mst.sithMesMstMaterial.grid.inspectionMemo',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'basicMaterial',
        label: 'label.sith.mst.sithMesMstMaterial.grid.basicMaterial',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'documentNumber',
        label: 'label.sith.mst.sithMesMstMaterial.grid.documentNumber',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'documentVersion',
        label: 'label.sith.mst.sithMesMstMaterial.grid.documentVersion',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'reserve1',
        label: 'label.sith.mst.sithMesMstMaterial.grid.reserve1',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'reserve2',
        label: 'label.sith.mst.sithMesMstMaterial.grid.reserve2',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'reserve3',
        label: 'label.sith.mst.sithMesMstMaterial.grid.reserve3',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'reserve4',
        label: 'label.sith.mst.sithMesMstMaterial.grid.reserve4',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'reserve5',
        label: 'label.sith.mst.sithMesMstMaterial.grid.reserve5',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'makeOrBuy',
        label: 'label.sith.mst.sithMesMstMaterial.grid.makeOrBuy',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '0', text: 'MAKE' },
                            { value: '1', text: 'BUY' }
            ]
                }
        },
        {
        key: 'maintenanceStatus',
        label: 'label.sith.mst.sithMesMstMaterial.grid.maintenanceStatus',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'baMaintainerRealName',
        label: 'label.sith.mst.sithMesMstMaterial.grid.baMaintainerRealName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'baMaintainTime',
        label: 'label.sith.mst.sithMesMstMaterial.grid.baMaintainTime',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'omMaintainerRealName',
        label: 'label.sith.mst.sithMesMstMaterial.grid.omMaintainerRealName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'omMaintainTime',
        label: 'label.sith.mst.sithMesMstMaterial.grid.omMaintainTime',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'tcMaintainerRealName',
        label: 'label.sith.mst.sithMesMstMaterial.grid.tcMaintainerRealName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'tcMaintainTime',
        label: 'label.sith.mst.sithMesMstMaterial.grid.tcMaintainTime',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mpMaintainerRealName',
        label: 'label.sith.mst.sithMesMstMaterial.grid.mpMaintainerRealName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mpMaintainTime',
        label: 'label.sith.mst.sithMesMstMaterial.grid.mpMaintainTime',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'qmMaintainerRealName',
        label: 'label.sith.mst.sithMesMstMaterial.grid.qmMaintainerRealName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'qmMaintainTime',
        label: 'label.sith.mst.sithMesMstMaterial.grid.qmMaintainTime',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'purchaserRealName',
        label: 'label.sith.mst.sithMesMstMaterial.grid.purchaserRealName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'purchaserMaintainTime',
        label: 'label.sith.mst.sithMesMstMaterial.grid.purchaserMaintainTime',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'doMaintainerRealName',
        label: 'label.sith.mst.sithMesMstMaterial.grid.doMaintainerRealName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'doMaintainTime',
        label: 'label.sith.mst.sithMesMstMaterial.grid.doMaintainTime',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesMstMaterial.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'createdByName',
        label: 'label.sith.mst.sithMesMstMaterial.grid.createdByName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    statusFilter : '',
    workOrderCodeFilter : '',
    projectKamIdFilter : '',
    bgFilter : '',
    standardPartFilter : '',
    materialFilter : '',
    plantFilter : '',
    materialDescriptionFilter : '',
    engDescriptionFilter : '',
    longTextFilter : '',
    languageFilter : '',
    mtypeFilter : '',
    bunitFilter : '',
    salesOrgFilter : '',
    distChannelFilter : '',
    oldMaterialNoFilter : '',
    matGroupFilter : '',
    externalMaterialGroupFilter : '',
    siemensPartNumberFilter : '',
    taxCategoryFilter : '',
    taxClassFilter : '',
    minOrderQtyFilter : '',
    deliveryPlantFilter : '',
    minDeliveryQtyFilter : '',
    cashDiscountFilter : '',
    matPricingGroupFilter : '',
    accountGroupFilter : '',
    matStatisticsGroupFilter : '',
    generalItemCategoryGroupFilter : '',
    itemCategoryGroupFilter : '',
    productHierarchyFilter : '',
    loadingGroupFilter : '',
    availabilityCheckFilter : '',
    profitCenterFilter : '',
    transportGroupFilter : '',
    grGiNumberFilter : '',
    storageBinFilter : '',
    overheadGroupFilter : '',
    valuationClassFilter : '',
    priceUnitFilter : '',
    lotSizeCostEstimateFilter : '',
    standardPriceFilter : '',
    priceControlFilter : '',
    withQtyStructureFilter : '',
    matOriginFilter : '',
    lotSizeFilter : '',
    mrpFilter : '',
    mrpTypeFilter : '',
    mrpControllerFilter : '',
    schedulingMarginKeyFilter : '',
    consumptionModeFilter : '',
    fwdConsPerFilter : '',
    bwdConsPerFilter : '',
    mixedMrpIndicatorFilter : '',
    proSheProfileFilter : '',
    specialProcTypeFilter : '',
    strategyGroupFilter : '',
    recordPointFilter : '',
    minLotSzeFilter : '',
    maxLotSizeFilter : '',
    fixLotSizeFilter : '',
    maxStockLevelFilter : '',
    procTypeFilter : '',
    purchasingGroupFilter : '',
    defaultStorageLocationFilter : '',
    issueStorageLocationFilter : '',
    plannedDeliveryTimeFilter : '',
    grProcessingTimeFilter : '',
    safeStockFilter : '',
    individualCollFilter : '',
    inHouseProductionTimeFilter : '',
    interOperationTimeFilter : '',
    issueUnitFilter : '',
    materialDescriptionZHFilter : '',
    textIdFilter : '',
    languageKeyFilter : '',
    textMpFilter : '',
    textEngFilter : '',
    textQaFilter : '',
    safetyTime1Filter : '',
    safetyTime2Filter : '',
    plFilter : '',
    isDepositedFilter : '',
    followUpMaterialRteFilter : '',
    followUpMaterialLteFilter : '',
    efODateFilter : '',
    bulkFilter : '',
    eslocFilter : '',
    slocFilter : '',
    roundingValFilter : '',
    bFilter : '',
    srceListFilter : '',
    inspectionIntervalFilter : '',
    codeNumberFilter : '',
    movavgPriceFilter : '',
    msFilter : '',
    productNumberSortFilter : '',
    industryStdDescFilter : '',
    bmrFilter : '',
    grossWeightFilter : '',
    netWeightFilter : '',
    weightUnitFilter : '',
    dimensionsFilter : '',
    inspectionMemoFilter : '',
    basicMaterialFilter : '',
    documentNumberFilter : '',
    documentVersionFilter : '',
    reserve1Filter : '',
    reserve2Filter : '',
    reserve3Filter : '',
    reserve4Filter : '',
    reserve5Filter : '',
    makeOrBuyFilter : '',
    maintenanceStatusFilter : '',
    baMaintainerFilter : '',
    baMaintainerRealNameFilter : '',
    baMaintainTimeRteFilter : '',
    baMaintainTimeLteFilter : '',
    omMaintainerFilter : '',
    omMaintainerRealNameFilter : '',
    omMaintainTimeRteFilter : '',
    omMaintainTimeLteFilter : '',
    tcMaintainerFilter : '',
    tcMaintainerRealNameFilter : '',
    tcMaintainTimeRteFilter : '',
    tcMaintainTimeLteFilter : '',
    mpMaintainerFilter : '',
    mpMaintainerRealNameFilter : '',
    mpMaintainTimeRteFilter : '',
    mpMaintainTimeLteFilter : '',
    qmMaintainerFilter : '',
    qmMaintainerRealNameFilter : '',
    qmMaintainTimeRteFilter : '',
    qmMaintainTimeLteFilter : '',
    purchaserFilter : '',
    purchaserRealNameFilter : '',
    purchaserMaintainTimeRteFilter : '',
    purchaserMaintainTimeLteFilter : '',
    doMaintainerFilter : '',
    doMaintainerRealNameFilter : '',
    doMaintainTimeRteFilter : '',
    doMaintainTimeLteFilter : '',
    createdByFilter : '',
    createdByRealNameFilter : '',
    heightFilter : '',
    widthFilter : '',
    lengthFilter : '',
    volumeFilter : '',
    volumeUnitFilter : '',
    warehouseNumberFilter : '',
    workflowQueryTypeFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'statusFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.status',
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emActProcessStatus'
            ,showLabelSelectOne: true
                    ,selectFilter:{processBusinessEntityFilter:'SithMesMstMaterial',statusFilter:1}
        }
        },
        {
        key: 'workOrderCodeFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.workOrderCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'projectKamIdFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.projectKamId',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'bgFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.bg',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'standardPartFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.standardPart',
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'materialFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.material',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'plantFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.plant',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'engDescriptionFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.engDescription',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'longTextFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.longText',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'languageFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.language',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mtypeFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.mtype',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'bunitFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.bunit',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'salesOrgFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.salesOrg',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'distChannelFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.distChannel',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'oldMaterialNoFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.oldMaterialNo',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'matGroupFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.matGroup',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'externalMaterialGroupFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.externalMaterialGroup',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'siemensPartNumberFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.siemensPartNumber',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'taxCategoryFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.taxCategory',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'taxClassFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.taxClass',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'minOrderQtyFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.minOrderQty',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'deliveryPlantFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.deliveryPlant',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'minDeliveryQtyFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.minDeliveryQty',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'cashDiscountFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.cashDiscount',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'matPricingGroupFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.matPricingGroup',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'accountGroupFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.accountGroup',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'matStatisticsGroupFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.matStatisticsGroup',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'generalItemCategoryGroupFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.generalItemCategoryGroup',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'itemCategoryGroupFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.itemCategoryGroup',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'productHierarchyFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.productHierarchy',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'loadingGroupFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.loadingGroup',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'availabilityCheckFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.availabilityCheck',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'profitCenterFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.profitCenter',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'transportGroupFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.transportGroup',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'grGiNumberFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.grGiNumber',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'storageBinFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.storageBin',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'overheadGroupFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.overheadGroup',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'valuationClassFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.valuationClass',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'priceUnitFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.priceUnit',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'lotSizeCostEstimateFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.lotSizeCostEstimate',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'standardPriceFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.standardPrice',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'priceControlFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.priceControl',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'withQtyStructureFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.withQtyStructure',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'matOriginFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.matOrigin',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'lotSizeFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.lotSize',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mrpFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.mrp',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mrpTypeFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.mrpType',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mrpControllerFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.mrpController',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'schedulingMarginKeyFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.schedulingMarginKey',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'consumptionModeFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.consumptionMode',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'fwdConsPerFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.fwdConsPer',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'bwdConsPerFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.bwdConsPer',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mixedMrpIndicatorFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.mixedMrpIndicator',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'proSheProfileFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.proSheProfile',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'specialProcTypeFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.specialProcType',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'strategyGroupFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.strategyGroup',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'recordPointFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.recordPoint',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'minLotSzeFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.minLotSze',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'maxLotSizeFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.maxLotSize',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'fixLotSizeFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.fixLotSize',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'maxStockLevelFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.maxStockLevel',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'procTypeFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.procType',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'purchasingGroupFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.purchasingGroup',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'defaultStorageLocationFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.defaultStorageLocation',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'issueStorageLocationFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.issueStorageLocation',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'plannedDeliveryTimeFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.plannedDeliveryTime',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'grProcessingTimeFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.grProcessingTime',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'safeStockFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.safeStock',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'individualCollFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.individualColl',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'inHouseProductionTimeFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.inHouseProductionTime',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'interOperationTimeFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.interOperationTime',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'issueUnitFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.issueUnit',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'materialDescriptionZHFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.materialDescriptionZH',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'textIdFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.textId',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'languageKeyFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.languageKey',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'textMpFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.textMp',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'textEngFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.textEng',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'textQaFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.textQa',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'safetyTime1Filter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.safetyTime1',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'safetyTime2Filter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.safetyTime2',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'plFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.pl',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'isDepositedFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.isDeposited',
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'followUpMaterialRteFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.followUpMaterialRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'followUpMaterialLteFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.followUpMaterialLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'efODateFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.efODate',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'bulkFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.bulk',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'eslocFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.esloc',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'slocFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.sloc',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'roundingValFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.roundingVal',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'bFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.b',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'srceListFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.srceList',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'inspectionIntervalFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.inspectionInterval',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'codeNumberFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.codeNumber',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'movavgPriceFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.movavgPrice',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'msFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.ms',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'productNumberSortFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.productNumberSort',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'industryStdDescFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.industryStdDesc',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'bmrFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.bmr',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'grossWeightFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.grossWeight',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'netWeightFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.netWeight',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'weightUnitFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.weightUnit',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'dimensionsFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.dimensions',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'inspectionMemoFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.inspectionMemo',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'basicMaterialFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.basicMaterial',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'documentNumberFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.documentNumber',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'documentVersionFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.documentVersion',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'reserve1Filter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.reserve1',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'reserve2Filter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.reserve2',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'reserve3Filter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.reserve3',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'reserve4Filter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.reserve4',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'reserve5Filter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.reserve5',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'makeOrBuyFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.makeOrBuy',
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
         ,options: [
                { value: '0', text: 'MAKE' },
                { value: '1', text: 'BUY' }
            ]
        }
        },
        {
        key: 'maintenanceStatusFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.maintenanceStatus',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'baMaintainerRealNameFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.baMaintainerRealName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'baMaintainTimeRteFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.baMaintainTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'baMaintainTimeLteFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.baMaintainTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'omMaintainerRealNameFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.omMaintainerRealName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'omMaintainTimeRteFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.omMaintainTimeRte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'omMaintainTimeLteFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.omMaintainTimeLte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tcMaintainerRealNameFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.tcMaintainerRealName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tcMaintainTimeRteFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.tcMaintainTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tcMaintainTimeLteFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.tcMaintainTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mpMaintainerRealNameFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.mpMaintainerRealName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mpMaintainTimeRteFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.mpMaintainTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mpMaintainTimeLteFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.mpMaintainTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'qmMaintainerRealNameFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.qmMaintainerRealName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'qmMaintainTimeRteFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.qmMaintainTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'qmMaintainTimeLteFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.qmMaintainTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'purchaserRealNameFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.purchaserRealName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'purchaserMaintainTimeRteFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.purchaserMaintainTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'purchaserMaintainTimeLteFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.purchaserMaintainTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'doMaintainerRealNameFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.doMaintainerRealName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'doMaintainTimeRteFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.doMaintainTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'doMaintainTimeLteFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.doMaintainTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'createdByRealNameFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.createdByRealName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'heightFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.height',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'widthFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.width',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'lengthFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.length',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'volumeFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.volume',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'volumeUnitFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.volumeUnit',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'warehouseNumberFilter',
        label: 'label.sith.mst.sithMesMstMaterial.filter.warehouseNumber',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
];
const sithMesMstMaterialBasicFilterConfigs = [
        {
        key: 'plantFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.plant',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'materialFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.material',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'materialDescriptionZHFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.materialDescriptionZH',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'engDescriptionFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.engDescription',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'languageFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.language',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mtypeFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.mtype',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'bunitFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.bunit',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'procTypeFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.procType',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'specialProcTypeFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.specialProcType',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mrpTypeFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.mrpType',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mrpControllerFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.mrpController',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'lotSizeFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.lotSize',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'individualCollFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.individualColl',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'itemCategoryGroupFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.itemCategoryGroup',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'followUpMaterialFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.followUpMaterial',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'efODateFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.efODate',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'bulkFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.bulk',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'eslocFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.esloc',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'slocFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.sloc',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'safeStockFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.safeStock',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'recordPointFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.recordPoint',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'minLotSzeFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.minLotSze',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'roundingValFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.roundingVal',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'bFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.b',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'srceListFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.srceList',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'purchasingGroupFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.purchasingGroup',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'matGroupFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.matGroup',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'plannedDeliveryTimeFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.plannedDeliveryTime',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'inHouseProductionTimeFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.inHouseProductionTime',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'grProcessingTimeFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.grProcessingTime',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'inspectionIntervalFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.inspectionInterval',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'codeNumberFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.codeNumber',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'salesOrgFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.salesOrg',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'distChannelFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.distChannel',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'productHierarchyFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.productHierarchy',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'profitCenterFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.profitCenter',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'loadingGroupFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.loadingGroup',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'overheadGroupFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.overheadGroup',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'valuationClassFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.valuationClass',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'priceControlFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.priceControl',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'movavgPriceFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.movavgPrice',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'standardPriceFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.standardPrice',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'priceUnitFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.priceUnit',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'availabilityCheckFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.availabilityCheck',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mrpFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.mrp',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'msFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.ms',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'consumptionModeFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.consumptionMode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'strategyGroupFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.strategyGroup',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'bwdConsPerFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.bwdConsPer',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'fwdConsPerFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.fwdConsPer',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'schedulingMarginKeyFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.schedulingMarginKey',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'safetyTime1Filter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.safetyTime1',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'safetyTime2Filter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.safetyTime2',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'oldMaterialNoFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.oldMaterialNo',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'productNumberSortFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.productNumberSort',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'industryStdDescFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.industryStdDesc',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'bmrFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.bmr',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'grossWeightFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.grossWeight',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'netWeightFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.netWeight',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'weightUnitFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.weightUnit',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'heightFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.height',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'widthFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.width',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'lengthFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.length',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'dimensionsFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.dimensions',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'volumeFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.volume',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'volumeUnitFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.volumeUnit',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'warehouseNumberFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.warehouseNumber',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'longTextFilter',
        label: 'label.sith.mst.sithMesMstMaterialBasic.filter.longText',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'projectKamId',
        label: 'label.sith.mst.sithMesMstMaterial.entity.projectKamId',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'bg',
        label: 'label.sith.mst.sithMesMstMaterial.entity.bg',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'standardPart',
        label: 'label.sith.mst.sithMesMstMaterial.entity.standardPart',
        sortable: true,
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'material',
        label: 'label.sith.mst.sithMesMstMaterial.entity.material',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'plant',
        label: 'label.sith.mst.sithMesMstMaterial.entity.plant',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'engDescription',
        label: 'label.sith.mst.sithMesMstMaterial.entity.engDescription',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'longText',
        label: 'label.sith.mst.sithMesMstMaterial.entity.longText',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'language',
        label: 'label.sith.mst.sithMesMstMaterial.entity.language',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mtype',
        label: 'label.sith.mst.sithMesMstMaterial.entity.mtype',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'bunit',
        label: 'label.sith.mst.sithMesMstMaterial.entity.bunit',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'salesOrg',
        label: 'label.sith.mst.sithMesMstMaterial.entity.salesOrg',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'distChannel',
        label: 'label.sith.mst.sithMesMstMaterial.entity.distChannel',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'oldMaterialNo',
        label: 'label.sith.mst.sithMesMstMaterial.entity.oldMaterialNo',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'matGroup',
        label: 'label.sith.mst.sithMesMstMaterial.entity.matGroup',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'externalMaterialGroup',
        label: 'label.sith.mst.sithMesMstMaterial.entity.externalMaterialGroup',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'siemensPartNumber',
        label: 'label.sith.mst.sithMesMstMaterial.entity.siemensPartNumber',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'taxCategory',
        label: 'label.sith.mst.sithMesMstMaterial.entity.taxCategory',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'taxClass',
        label: 'label.sith.mst.sithMesMstMaterial.entity.taxClass',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'minOrderQty',
        label: 'label.sith.mst.sithMesMstMaterial.entity.minOrderQty',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'deliveryPlant',
        label: 'label.sith.mst.sithMesMstMaterial.entity.deliveryPlant',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'minDeliveryQty',
        label: 'label.sith.mst.sithMesMstMaterial.entity.minDeliveryQty',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'cashDiscount',
        label: 'label.sith.mst.sithMesMstMaterial.entity.cashDiscount',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'matPricingGroup',
        label: 'label.sith.mst.sithMesMstMaterial.entity.matPricingGroup',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'accountGroup',
        label: 'label.sith.mst.sithMesMstMaterial.entity.accountGroup',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'matStatisticsGroup',
        label: 'label.sith.mst.sithMesMstMaterial.entity.matStatisticsGroup',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'generalItemCategoryGroup',
        label: 'label.sith.mst.sithMesMstMaterial.entity.generalItemCategoryGroup',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'itemCategoryGroup',
        label: 'label.sith.mst.sithMesMstMaterial.entity.itemCategoryGroup',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'productHierarchy',
        label: 'label.sith.mst.sithMesMstMaterial.entity.productHierarchy',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'loadingGroup',
        label: 'label.sith.mst.sithMesMstMaterial.entity.loadingGroup',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'availabilityCheck',
        label: 'label.sith.mst.sithMesMstMaterial.entity.availabilityCheck',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'profitCenter',
        label: 'label.sith.mst.sithMesMstMaterial.entity.profitCenter',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'transportGroup',
        label: 'label.sith.mst.sithMesMstMaterial.entity.transportGroup',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'grGiNumber',
        label: 'label.sith.mst.sithMesMstMaterial.entity.grGiNumber',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'storageBin',
        label: 'label.sith.mst.sithMesMstMaterial.entity.storageBin',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'overheadGroup',
        label: 'label.sith.mst.sithMesMstMaterial.entity.overheadGroup',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'valuationClass',
        label: 'label.sith.mst.sithMesMstMaterial.entity.valuationClass',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'priceUnit',
        label: 'label.sith.mst.sithMesMstMaterial.entity.priceUnit',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'lotSizeCostEstimate',
        label: 'label.sith.mst.sithMesMstMaterial.entity.lotSizeCostEstimate',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'standardPrice',
        label: 'label.sith.mst.sithMesMstMaterial.entity.standardPrice',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'priceControl',
        label: 'label.sith.mst.sithMesMstMaterial.entity.priceControl',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'withQtyStructure',
        label: 'label.sith.mst.sithMesMstMaterial.entity.withQtyStructure',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'matOrigin',
        label: 'label.sith.mst.sithMesMstMaterial.entity.matOrigin',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'lotSize',
        label: 'label.sith.mst.sithMesMstMaterial.entity.lotSize',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mrp',
        label: 'label.sith.mst.sithMesMstMaterial.entity.mrp',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mrpType',
        label: 'label.sith.mst.sithMesMstMaterial.entity.mrpType',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mrpController',
        label: 'label.sith.mst.sithMesMstMaterial.entity.mrpController',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'schedulingMarginKey',
        label: 'label.sith.mst.sithMesMstMaterial.entity.schedulingMarginKey',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'consumptionMode',
        label: 'label.sith.mst.sithMesMstMaterial.entity.consumptionMode',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'fwdConsPer',
        label: 'label.sith.mst.sithMesMstMaterial.entity.fwdConsPer',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'bwdConsPer',
        label: 'label.sith.mst.sithMesMstMaterial.entity.bwdConsPer',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mixedMrpIndicator',
        label: 'label.sith.mst.sithMesMstMaterial.entity.mixedMrpIndicator',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'proSheProfile',
        label: 'label.sith.mst.sithMesMstMaterial.entity.proSheProfile',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'specialProcType',
        label: 'label.sith.mst.sithMesMstMaterial.entity.specialProcType',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'strategyGroup',
        label: 'label.sith.mst.sithMesMstMaterial.entity.strategyGroup',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'recordPoint',
        label: 'label.sith.mst.sithMesMstMaterial.entity.recordPoint',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'minLotSze',
        label: 'label.sith.mst.sithMesMstMaterial.entity.minLotSze',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'maxLotSize',
        label: 'label.sith.mst.sithMesMstMaterial.entity.maxLotSize',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'fixLotSize',
        label: 'label.sith.mst.sithMesMstMaterial.entity.fixLotSize',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'maxStockLevel',
        label: 'label.sith.mst.sithMesMstMaterial.entity.maxStockLevel',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'procType',
        label: 'label.sith.mst.sithMesMstMaterial.entity.procType',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'purchasingGroup',
        label: 'label.sith.mst.sithMesMstMaterial.entity.purchasingGroup',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'defaultStorageLocation',
        label: 'label.sith.mst.sithMesMstMaterial.entity.defaultStorageLocation',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'issueStorageLocation',
        label: 'label.sith.mst.sithMesMstMaterial.entity.issueStorageLocation',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'plannedDeliveryTime',
        label: 'label.sith.mst.sithMesMstMaterial.entity.plannedDeliveryTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'grProcessingTime',
        label: 'label.sith.mst.sithMesMstMaterial.entity.grProcessingTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'safeStock',
        label: 'label.sith.mst.sithMesMstMaterial.entity.safeStock',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'individualColl',
        label: 'label.sith.mst.sithMesMstMaterial.entity.individualColl',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'inHouseProductionTime',
        label: 'label.sith.mst.sithMesMstMaterial.entity.inHouseProductionTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'interOperationTime',
        label: 'label.sith.mst.sithMesMstMaterial.entity.interOperationTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'issueUnit',
        label: 'label.sith.mst.sithMesMstMaterial.entity.issueUnit',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'materialDescriptionZH',
        label: 'label.sith.mst.sithMesMstMaterial.entity.materialDescriptionZH',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'textId',
        label: 'label.sith.mst.sithMesMstMaterial.entity.textId',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'languageKey',
        label: 'label.sith.mst.sithMesMstMaterial.entity.languageKey',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'textMp',
        label: 'label.sith.mst.sithMesMstMaterial.entity.textMp',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'textEng',
        label: 'label.sith.mst.sithMesMstMaterial.entity.textEng',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'textQa',
        label: 'label.sith.mst.sithMesMstMaterial.entity.textQa',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'safetyTime1',
        label: 'label.sith.mst.sithMesMstMaterial.entity.safetyTime1',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'safetyTime2',
        label: 'label.sith.mst.sithMesMstMaterial.entity.safetyTime2',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'pl',
        label: 'label.sith.mst.sithMesMstMaterial.entity.pl',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'isDeposited',
        label: 'label.sith.mst.sithMesMstMaterial.entity.isDeposited',
        sortable: true,
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'followUpMaterial',
        label: 'label.sith.mst.sithMesMstMaterial.entity.followUpMaterial',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'efODate',
        label: 'label.sith.mst.sithMesMstMaterial.entity.efODate',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'bulk',
        label: 'label.sith.mst.sithMesMstMaterial.entity.bulk',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'esloc',
        label: 'label.sith.mst.sithMesMstMaterial.entity.esloc',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'sloc',
        label: 'label.sith.mst.sithMesMstMaterial.entity.sloc',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'roundingVal',
        label: 'label.sith.mst.sithMesMstMaterial.entity.roundingVal',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'b',
        label: 'label.sith.mst.sithMesMstMaterial.entity.b',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'srceList',
        label: 'label.sith.mst.sithMesMstMaterial.entity.srceList',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'inspectionInterval',
        label: 'label.sith.mst.sithMesMstMaterial.entity.inspectionInterval',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'codeNumber',
        label: 'label.sith.mst.sithMesMstMaterial.entity.codeNumber',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'movavgPrice',
        label: 'label.sith.mst.sithMesMstMaterial.entity.movavgPrice',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ms',
        label: 'label.sith.mst.sithMesMstMaterial.entity.ms',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'productNumberSort',
        label: 'label.sith.mst.sithMesMstMaterial.entity.productNumberSort',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'industryStdDesc',
        label: 'label.sith.mst.sithMesMstMaterial.entity.industryStdDesc',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'bmr',
        label: 'label.sith.mst.sithMesMstMaterial.entity.bmr',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'grossWeight',
        label: 'label.sith.mst.sithMesMstMaterial.entity.grossWeight',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'netWeight',
        label: 'label.sith.mst.sithMesMstMaterial.entity.netWeight',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'weightUnit',
        label: 'label.sith.mst.sithMesMstMaterial.entity.weightUnit',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'dimensions',
        label: 'label.sith.mst.sithMesMstMaterial.entity.dimensions',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'inspectionMemo',
        label: 'label.sith.mst.sithMesMstMaterial.entity.inspectionMemo',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'basicMaterial',
        label: 'label.sith.mst.sithMesMstMaterial.entity.basicMaterial',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'documentNumber',
        label: 'label.sith.mst.sithMesMstMaterial.entity.documentNumber',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'documentVersion',
        label: 'label.sith.mst.sithMesMstMaterial.entity.documentVersion',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'reserve1',
        label: 'label.sith.mst.sithMesMstMaterial.entity.reserve1',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'reserve2',
        label: 'label.sith.mst.sithMesMstMaterial.entity.reserve2',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'reserve3',
        label: 'label.sith.mst.sithMesMstMaterial.entity.reserve3',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'reserve4',
        label: 'label.sith.mst.sithMesMstMaterial.entity.reserve4',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'reserve5',
        label: 'label.sith.mst.sithMesMstMaterial.entity.reserve5',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'makeOrBuy',
        label: 'label.sith.mst.sithMesMstMaterial.entity.makeOrBuy',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'maintenanceStatus',
        label: 'label.sith.mst.sithMesMstMaterial.entity.maintenanceStatus',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesMstMaterial.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        },
]

export {SithMesMstMaterial, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs, sithMesMstMaterialBasicFilterConfigs

, editViewVoConfigs, sithMesMstMaterialBasicVoConfigs
}
